// ======================================================================
// File Name       : DateTimeMinMax
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import moment from 'moment';
import { InputGroup } from 'react-bootstrap';
import { DEFAULT_DATE_FORMAT, ERROR_TYPE, DEFAULT_DATE_SHORT_FORMAT_SERVER } from '../constants/index';
import { MIN_MAX_DATE_TXT, WRONG_CREATE_DATE_TXT, WRONG_SIX_MONTH_PERIOD_TXT } from '../utils/index';
import MessageValidate from '../components/MessageValidate';
import * as MessageTemplate from '../constants/MessageTemplate';

class DateTimeMinMax extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorType: ERROR_TYPE.ERROR,
      errorVisible: false,
      errorMessage: WRONG_CREATE_DATE_TXT,
      value: '',
    };
    this.validateFromTo = this.validateFromTo.bind(this);
    this.validation = this.validation.bind(this);
    this.minMaxDateTxt = props.minMaxDateTxt ? props.minMaxDateTxt : MIN_MAX_DATE_TXT;
    this.errorMessage = props.wrongPeriodTxt ? props.wrongPeriodTxt : WRONG_CREATE_DATE_TXT;
    this.format = DEFAULT_DATE_FORMAT;
  }

  componentWillReceiveProps(nextProps) {
    this.validateFromTo(nextProps);
  }

  validateFromTo(nextProps) {
    const shouldNotCheck =
      !(nextProps.dateFrom && nextProps.dateTo) ||
      nextProps.dateFrom === this.minMaxDateTxt ||
      nextProps.dateTo === this.minMaxDateTxt;
    const { shouldValidateRange } = nextProps;
    if (shouldNotCheck && !shouldValidateRange) {
      this.setState({
        errorVisible: false,
        errorMessage: '',
      });
      return true;
    }
    let isValid = true;
    const mDateFrom = nextProps.dateFrom ? moment(nextProps.dateFrom) : null;
    const mDateTo = nextProps.dateTo ? moment(nextProps.dateTo) : null;
    if (mDateFrom && mDateTo) {
      isValid = mDateFrom.isSameOrBefore(mDateTo);
    }
    // START #5854 Validate period allowed to be searched (6 months)
    if (shouldValidateRange && mDateFrom && mDateTo && isValid) {
      const thePreviousSixMonth = mDateTo.subtract(6, 'months').endOf('date').format(DEFAULT_DATE_FORMAT);
      isValid = mDateFrom.isSameOrAfter(thePreviousSixMonth);
      this.setState({
        errorVisible: !isValid,
        errorMessage: WRONG_SIX_MONTH_PERIOD_TXT,
      });
      return isValid;
    }
    // END #5854
    this.setState({
      errorVisible: !isValid,
      errorMessage: this.errorMessage,
    });
    return isValid;
  }

  validation() {
    return this.validateFromTo(this.props);
  }

  render() {
    return (
      <div>
        <MessageValidate
          errorType={this.state.errorType}
          visible={this.state.errorVisible}
          errorMessage={this.state.errorMessage}
        />
      </div>
    );
  }
}

export default DateTimeMinMax;
